'use strict';

/**
 * @ngdoc function
 * @name scrapQcrmApp.controller:AboutCtrl
 * @description
 * # AboutCtrl
 * Controller of the scrapQcrmApp
 */
angular.module('scrapQcrmApp')
  .controller('AboutCtrl', function($scope, $global, authentication, $state, growl, dashboard, $rootScope, $stateParams) {
    /*! Copyright (c) 2011 Piotr Rochala (http://rocha.la)
     * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
     * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
     *
     * Version: 1.3.6
     *
     */
    // Init function
    (function() {
      if (!$rootScope.loginData) {
        console.log("Session error, changing state");
        growl.error("Invalid session, please log in again");
        $state.go("login");
      }
      $scope.selectedCity = {
        city: $rootScope.loginData.city
      };
      $scope.city = [];
      dashboard.getAllCity().then(function(res) {
        if (res.status === 'SUCCESS' && res.data && res.data.cities) {
          $rootScope.allCityData = res.data.cities;
          // if admin registration collection contains a city field, then restrict this admin to only this city
          if ($rootScope.loginData.adminCity) {
            $scope.city.push($rootScope.loginData.adminCity);
          } else { //else allow for all cities
            for (let City in res.data.cities) {
              if ($scope.city.indexOf(res.data.cities[City].name) === -1) {
                $scope.city.push(res.data.cities[City].name);
              }
            }
          }
        }
      })
    })();
    
    $scope.changeCity = function(val) {
      $rootScope.loginData.city = $scope.selectedCity.city;
      $global.setLocalItem("loginData", $rootScope.loginData, true);
      $state.go($state.current, $stateParams, {
        reload: true
      });
    };
    
    $scope.crmlogout = function() {
      $global.removeLocalItem("authentication");
      authentication.logout().then(function(res) {
        growl.success("Logout successful");
        $state.go("login");
      });
    }
  });
